// import deleteCookie from "@/utils/deleteCookie"

// DTO
import { ContactLoginResponseDTO, ContactLoginDTO } from "@/services/AuthService.interface"
import { UserInfo } from "@/services/AuthService.interface"

// Model
import LoginForm from "@/model/Form/LoginForm"

// Logic
import setTokensInCookies from "@/logic/contact/setTokensInCookies"
import setUserIdInLocalStorage from "@/logic/contact/setUserIdInLocalStorage"
import resetLoginForm from "@/logic/user-info/resetLoginForm"
import resetRegisterForm from "@/logic/user-info/resetRegisterForm"
import navigateAfterAuth from "@/logic/contact/navigateAfterAuth"

// Config
import defaultPhoneCodes from "@/config/loginRegisterLegacy/defaultPhoneCodes"

// State
import loggedInUser from "@/state/loggedInUser"
import locale from "@/state/locale"
import isPasswordIncorrect from "@/state/isPasswordIncorrect"

// Tracking
import setEmailInLocalStorage from "@/tracking/setEmailInLocalStorage"

// store
import store from "@/store"

const login = async (form: LoginForm): Promise<void> => {
	if (!form.getIsFormValid())
		throw new Error(
			"cannot send an invalid form, make sure you perform this check before making this call"
		)
	if (!locale.value) throw new Error("locale.value cannot be undefined")

	isPasswordIncorrect.value = false

	try {
		const loginDTO: ContactLoginDTO = {email: form.email!, password: form.password as string}

		const loginResponse: ContactLoginResponseDTO | null = await store.dispatch("auth/login", loginDTO)

		if (!loginResponse) throw new Error("LOGIN ERROR")


		// setTokensInCookies(loginResponse.tokens)
		setUserIdInLocalStorage(loginResponse.userInfo)

		// if (!loginResponse.userInfo.phone_code) {
		// 	const defaultPhoneCode: string =
		// 		defaultPhoneCodes[window.locale.replace("_", "-")]
		// 	loginResponse.userInfo.phone_code = defaultPhoneCode
		// }

		const userInfo: UserInfo = loginResponse.userInfo

		loggedInUser.value = userInfo

		// delete legacy token
		// deleteCookie("user-token")

		resetLoginForm()
		resetRegisterForm()
		setEmailInLocalStorage(userInfo.email)

		await navigateAfterAuth(userInfo.email)
	} catch (err) {
		console.error(err)
		isPasswordIncorrect.value = true
	}
}

export default login
